import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from '@angular/core';
import {SiteDiaryItem, SiteDiaryService} from '../../services/SiteDiary.service';



@Component({
  selector: 'SiteDiary-Details-table',
  templateUrl: './SiteDiary-Details-table.component.html',
  styleUrls: ['./SiteDiary-Details-table.component.sass']
})
export class SiteDiaryDetailsActivityComponent implements OnChanges {

  @Input() public divClick:any
  @Input() public summaryData: SiteDiaryItem
  @Input() public addActivty:any
  @Input() public isEdit:any
  @Output() tableEdit = new EventEmitter();

  public tableList:any[] = []

  public modulesize:any = []   //module页码
  public modulepage=1
  public currentId=0
  public per = 999
  public filterData = {
    equipment: '',
    ownership: '',
    order_key:'',
    order_direction:'asc'
  }
  public LabourList:any[] = []
  public OwnershipList:any[] = []
  public formatNumber(num: any): string {
     let  value = Number(num);
      if (isNaN(value)) return '0.0';
      return value.toFixed(1);
  }

  constructor(
    public service: SiteDiaryService,
  ) { }

  ngOnInit() {
    // this.getList()
    // console.log('divClick',this.divClick)
    const currentUser: any = document.querySelector('meta[name=current_user]');
    this.currentId = currentUser.dataset.id

  }

  //监听父组件传递过来的值
  ngOnChanges(changes:{[propKey:string]: SimpleChange }){
    //console.log(changes)
    if(changes['addActivty']){
      if(!changes['addActivty']['currentValue'])this.getList()
    }
    if(changes['divClick']){
        this.filterData = {
          equipment: '',
          ownership: '',
          order_key:'',
          order_direction:'asc'
        }
      this.getList()
    }
  }
   // 按钮权限
   permissionBtn(){
    if(!this.isEdit){
      return true
    }else{
      return false
    }
  }
  labourClick(){
    this.filterData.order_key = 'labour_name'
    this.filterData.order_direction = 'asc'
    this.getList()
  }
  plantClick(){
    this.filterData.order_key = 'equipment'
    this.filterData.order_direction = 'asc'
    this.getList()
  }
  ownershipClick(){
    this.filterData.order_key = 'ownership'
    this.filterData.order_direction = 'asc'
    this.getList()
  }
  //获取labour列表数据
  getList() {
    if(this.divClick === 'labour'){
      console.log(this.filterData,'filterData');
      
    let data = {site_diary_id:this.summaryData.id ,page:this.modulepage ,per:this.per,...this.filterData}
    console.log(data,'data');
    
      this.service.getSiteDiaryLabourList(data).subscribe((res:any)=>{
        //console.log(res)
        this.tableList = res.labour_items
        console.log(this.tableList,'tableList');
        if(this.LabourList.length <= 0 && this.OwnershipList.length <= 0){
          this.LabourList = Array.from(new Set(this.tableList.map(item => item.labour_name)));
          this.OwnershipList = Array.from(new Set(this.tableList.map(item => item.ownership)));
        }
        this.setCountList(res.labour_items.length,res.count)
      })
    }else if(this.divClick === 'plant'){
      let data = {site_diary_id:this.summaryData.id ,page:this.modulepage ,per:this.per,...this.filterData}

      this.service.getSiteDiaryPlantList(data).subscribe((res:any)=>{
        //console.log(res)
        this.tableList = res.plant_items
      })
    }else{
      let data = {site_diary_id:this.summaryData.id ,page:this.modulepage ,per:this.per}
      this.service.getActivitiesList(data).subscribe((res:any)=>{
        //console.log(res)
        this.tableList = res.activities
        this.setCountList(res.activities.length,res.count)
      })
    }
  }
  //过滤
  filterTable(){
    this.getList()
  }
  //分页处理
  setCountList(length:any,count:any){
    //console.log(Math.ceil(count/this.per))
    this.modulesize = []
    for(let i =0;i<Math.ceil(count/this.per);i++){
      this.modulesize.push("i")
      //console.log(this.modulesize)
    }
  }

  modulego(leftright:any){
    if(leftright == 'prev'){
      this.modulepage = this.modulepage>this.modulesize.length ? this.modulepage : this.modulepage-1
    }
  }

  //修改按钮
  editClick(item:any){
    jQuery('#top-menu').css('z-index','unset')
    this.tableEdit.emit(item)
  }

  deleteClick(item:any){
    //console.log(item)
    this.service.deleteActivities({site_diary_id:this.summaryData.id,activity_id:item.id}).subscribe((res:any)=>{
      this.getList()
    })
    // this.tableEdit.emit(item)
  }

}
